import { VALIDATION_RULES } from '../constants';

/**
 * 登录表单验证工具函数
 */

// 账号验证规则
export const accountRules = [
  {
    required: true,
    message: VALIDATION_RULES.REQUIRED_MESSAGES.ACCOUNT,
  },
];

// 密码验证规则
export const passwordRules = [
  {
    required: true,
    message: VALIDATION_RULES.REQUIRED_MESSAGES.PASSWORD,
  },
];

// 手机号验证规则
export const phoneRules = [
  {
    required: true,
    message: VALIDATION_RULES.REQUIRED_MESSAGES.PHONE,
  },
  {
    pattern: VALIDATION_RULES.PHONE_REGEX,
    message: VALIDATION_RULES.REQUIRED_MESSAGES.PHONE,
  },
];

// 验证码验证规则
export const verifyCodeRules = [
  {
    required: true,
    message: VALIDATION_RULES.REQUIRED_MESSAGES.VERIFY_CODE,
  },
];

// 验证手机号格式
export const validatePhone = (phone) => {
  return VALIDATION_RULES.PHONE_REGEX.test(phone);
};

// 验证表单字段是否为空
export const validateRequired = (value, fieldName) => {
  if (!value || value.trim() === '') {
    return {
      valid: false,
      message: VALIDATION_RULES.REQUIRED_MESSAGES[fieldName] || `请输入${fieldName}`
    };
  }
  return { valid: true };
};